import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AuditOutcomesFetchFailedAction = {
	type: 'AUDIT_OUTCOMES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AuditOutcomesFetchFailedAction => ({
	type: 'AUDIT_OUTCOMES_FETCH_FAILED',
	payload,
});
